<div class="adaptive-grow-1" *ngIf="changelogData">
  <div class="title-color">
    <h1 class="title">REGISTRO DE CAMBIOS</h1>
    <h3 class="title-list">Costos Integrales versión {{ changelogData.version }}</h3>
    <h6 class="title-list">
      Fecha de lanzamiento:
      {{ changelogData.releaseDate | date: "dd/MM/yyyy" }}
    </h6>
  </div>
  <br />
  <!-- Contenido -->
  <div class="fluent-container">
    <div
      class="example-large-box mat-elevation-z4"
      *ngIf="changelogData.featureDesc"
    >
      <div class="form-body">
        <h2 class="titulos-listas">NUEVAS CARACTERISTICAS:</h2>
      </div>
      <p class="changelog-text">{{ changelogData.featureDesc }}</p>
      <br>
    </div>
    <br />
    <div
      class="example-large-box mat-elevation-z4"
      *ngIf="changelogData.bugFixesDesc"
    >
      <div class="form-body">
        <h2 class="titulos-listas">CORRECCION DE ERRORES:</h2>
      </div>
      <p class="changelog-text">{{ changelogData.bugFixesDesc }}</p>
      <br>
    </div>
  </div>

  <br />
  <div class="modal-footer">
    <button type="submit" class="secondary-button" (click)="closeModal()">cerrar</button>
  </div>
  <br />
</div>